import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'rbr-calculation-base',
    templateUrl: './calculation-base.component.html',
    styleUrls: ['./calculation-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe, ComponentsModule]
})
export class CalculationBaseComponent {
    headerText = input<string>('RBR.CALCULATION_BASE.TITLE');
}
